import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangeSelectorModule } from '../forms/date-range-selector/date-range-selector.module';
import { DropdownModule } from '../forms/dropdown/dropdown.module';
import { InputModule } from '../forms/input/input.module';
import { CustomRequestQuoteComponent } from './custom-request-quote.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaWidgetModule } from '../recaptcha/recaptcha.module';

@NgModule({
  declarations: [CustomRequestQuoteComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DateRangeSelectorModule,
    DropdownModule,
    InputModule,
    RecaptchaWidgetModule,
  ],
  exports: [CustomRequestQuoteComponent],
})
export class CustomRequestQuoteModule {}
